import cx from 'clsx';

import styles from 'theme/components/modified-value.module.scss';

const ModifiedValue = ({ isModified, defaultValue, children }) =>
  defaultValue == null || !isModified ? (
    <span className={cx(isModified && styles.modified)}>{children}</span>
  ) : (
    <div>
      <span className={cx(isModified && styles.modified)}>{children}</span> <br />
      <span className={styles.default}>(Default: {defaultValue})</span>
    </div>
  );

export default ModifiedValue;
